"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketService = void 0;

var framework_1 = require("../../core/framework");

var Storage_1 = __importDefault(require("../../core/utilities/Storage"));

var LegalizeSDKError_1 = __importDefault(require("../../core/utilities/LegalizeSDKError"));

var entities_1 = require("../../entities");

var enums_1 = require("../../enums");

var Order_1 = require("../order/Order");

var BasketServiceStorage;

(function (BasketServiceStorage) {
  BasketServiceStorage["skus"] = "skus";
  BasketServiceStorage["calculatedSkus"] = "calculatedSkus";
})(BasketServiceStorage || (BasketServiceStorage = {}));

var BasketService =
/** @class */
function (_super) {
  __extends(BasketService, _super);

  function BasketService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.storage = new Storage_1.default("BasketService");
    _this.skus = new Map();
    return _this;
  }

  BasketService.getInstance = function () {
    if (!BasketService.instance) {
      BasketService.instance = new BasketService();
    }

    return BasketService.instance;
  };

  BasketService.prototype.init = function (authService, baseUrl, marketId) {
    this.marketId = marketId;
    this.authService = authService;
    this.orderService = new Order_1.OrderService(baseUrl);
    this.skus = this.convertSkusToMap(this.readFromStorage());
    this.handleAuthStateChange(this.authService.getState());
    this.authService.on("stateChanged", this.handleAuthStateChange.bind(this));
  };

  BasketService.prototype.isAuthenticated = function () {
    return this.authService.getState() === enums_1.AuthServiceState.authenticated;
  };

  BasketService.prototype.add = function (skuId, count) {
    return __awaiter(this, void 0, void 0, function () {
      var quantity, calculatedOrder, address, alreadyHasSku, skus, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 9,, 10]);

            quantity = count || 1;
            if (!this.isAuthenticated()) return [3
            /*break*/
            , 6];
            calculatedOrder = this.authService.getUser().cart;
            return [4
            /*yield*/
            , this.getAddress()];

          case 1:
            address = _a.sent();
            if (!calculatedOrder.id) return [3
            /*break*/
            , 3];
            alreadyHasSku = Boolean(calculatedOrder.skus.find(function (sku) {
              return sku.skuId === skuId;
            }));
            skus = void 0;

            if (alreadyHasSku) {
              skus = calculatedOrder.skus.map(function (sku) {
                return new entities_1.OrderSkuCreateInputEntity({
                  skuId: sku.skuId,
                  quantity: sku.skuId === skuId ? sku.quantity + 1 : sku.quantity
                });
              });
            } else {
              skus = [new entities_1.OrderSkuCreateInputEntity({
                skuId: skuId,
                quantity: quantity
              })].concat(this.extractOrderSkuCreateInput(calculatedOrder));
            }

            return [4
            /*yield*/
            , this.orderService.update(calculatedOrder.id, address.id, skus)];

          case 2:
            _a.sent();

            return [3
            /*break*/
            , 5];

          case 3:
            return [4
            /*yield*/
            , this.orderService.create(this.marketId, address.id, [new entities_1.OrderSkuCreateInputEntity({
              skuId: skuId,
              quantity: quantity
            })])];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            return [3
            /*break*/
            , 7];

          case 6:
            this.skus.set(skuId, this.skus.get(skuId) ? Number(this.skus.get(skuId)) + quantity : quantity);
            _a.label = 7;

          case 7:
            return [4
            /*yield*/
            , this.update()];

          case 8:
            return [2
            /*return*/
            , _a.sent()];

          case 9:
            error_1 = _a.sent();
            throw new LegalizeSDKError_1.default("Can not add sku to basket", error_1);

          case 10:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BasketService.prototype.remove = function (id, removeAll) {
    return __awaiter(this, void 0, void 0, function () {
      var cart, address, skus, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 9,, 10]);

            if (!this.isAuthenticated()) return [3
            /*break*/
            , 6];
            cart = this.authService.getUser().cart;
            return [4
            /*yield*/
            , this.getAddress()];

          case 1:
            address = _a.sent();
            skus = cart.skus.reduce(function (result, _a) {
              var skuId = _a.skuId,
                  quantity = _a.quantity;

              if (skuId === id) {
                if (quantity > 1 && !removeAll) {
                  result.push(new entities_1.OrderSkuCreateInputEntity({
                    skuId: id,
                    quantity: quantity - 1
                  }));
                }
              } else {
                result.push(new entities_1.OrderSkuCreateInputEntity({
                  skuId: skuId,
                  quantity: quantity
                }));
              }

              return result;
            }, []);
            if (!skus.length) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.orderService.update(cart.id, address.id, skus)];

          case 2:
            _a.sent();

            return [3
            /*break*/
            , 5];

          case 3:
            return [4
            /*yield*/
            , this.orderService.cancel(cart.id)];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            return [3
            /*break*/
            , 7];

          case 6:
            if (!removeAll && Number(this.skus.get(id)) > 1) {
              this.skus.set(id, Number(this.skus.get(id)) - 1);
            } else {
              this.skus.delete(id);
            }

            this.storage.put(BasketServiceStorage.skus, this.skus);
            _a.label = 7;

          case 7:
            return [4
            /*yield*/
            , this.update()];

          case 8:
            return [2
            /*return*/
            , _a.sent()];

          case 9:
            error_2 = _a.sent();
            throw new LegalizeSDKError_1.default("Can not remove sku from basket", error_2);

          case 10:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BasketService.prototype.get = function () {
    return Promise.resolve(this.isAuthenticated() ? this.authService.getUser().cart : new entities_1.CalculatedOrderEntity(this.storage.get(BasketServiceStorage.calculatedSkus)));
  };

  BasketService.prototype.update = function () {
    return __awaiter(this, void 0, void 0, function () {
      var emptyOrder, _a, _b, skus, location_1, calculatedSkus, error_3, error_4;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            emptyOrder = new entities_1.CalculatedOrderEntity();
            _c.label = 1;

          case 1:
            _c.trys.push([1, 10,, 11]);

            if (!this.isAuthenticated()) return [3
            /*break*/
            , 3];
            _a = this.emit;
            _b = ["update"];
            return [4
            /*yield*/
            , this.authService.updateUser()];

          case 2:
            _a.apply(this, _b.concat([_c.sent().cart]));

            return [2
            /*return*/
            ];

          case 3:
            skus = this.convertSkusToEntities(this.skus);
            location_1 = this.authService.getLocation();
            this.storage.put(BasketServiceStorage.skus, skus);
            if (!(location_1 && skus.length)) return [3
            /*break*/
            , 8];
            _c.label = 4;

          case 4:
            _c.trys.push([4, 6,, 7]);

            return [4
            /*yield*/
            , this.orderService.calculate(this.marketId, location_1.placeId, skus)];

          case 5:
            calculatedSkus = _c.sent();
            this.storage.put(BasketServiceStorage.calculatedSkus, calculatedSkus);
            this.emit("update", calculatedSkus);
            return [2
            /*return*/
            ];

          case 6:
            error_3 = _c.sent();
            this.emit("update", emptyOrder);
            return [2
            /*return*/
            ];

          case 7:
            return [3
            /*break*/
            , 9];

          case 8:
            this.storage.remove(BasketServiceStorage.skus);
            this.storage.remove(BasketServiceStorage.calculatedSkus);
            this.skus.clear();
            this.emit("update", emptyOrder);
            return [2
            /*return*/
            ];

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_4 = _c.sent();
            this.emit("update", emptyOrder);
            return [2
            /*return*/
            ];

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BasketService.prototype.readFromStorage = function () {
    var skus = this.storage.get(BasketServiceStorage.skus);
    return skus ? skus.map(function (sku) {
      return new entities_1.OrderSkuCreateInputEntity(sku);
    }) : [];
  };

  BasketService.prototype.convertSkusToEntities = function (skus) {
    return Array.from(skus.entries()).map(function (_a) {
      var skuId = _a[0],
          quantity = _a[1];
      return new entities_1.OrderSkuCreateInputEntity({
        skuId: skuId,
        quantity: quantity
      });
    });
  };

  BasketService.prototype.convertSkusToMap = function (skus) {
    var map = new Map();
    skus.forEach(function (sku) {
      map.set(sku.skuId, sku.quantity);
    });
    return map;
  };

  BasketService.prototype.getAddress = function () {
    return __awaiter(this, void 0, void 0, function () {
      var address;
      return __generator(this, function (_a) {
        address = this.authService.getAddress();
        if (address) return [2
        /*return*/
        , address];
        throw new LegalizeSDKError_1.default("Address not provided");
      });
    });
  };

  BasketService.prototype.extractOrderSkuCreateInput = function (calculatedOrder) {
    return calculatedOrder.skus.map(function (_a) {
      var skuId = _a.skuId,
          quantity = _a.quantity;
      return new entities_1.OrderSkuCreateInputEntity({
        skuId: skuId,
        quantity: quantity
      });
    });
  };

  BasketService.prototype.mergeBasket = function () {
    return __awaiter(this, void 0, void 0, function () {
      var localSkus, cart, address, error_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 7,, 8]);

            localSkus = this.readFromStorage();
            cart = this.authService.getUser().cart;
            return [4
            /*yield*/
            , this.getAddress()];

          case 1:
            address = _a.sent();
            if (!localSkus.length) return [3
            /*break*/
            , 5];
            if (!(cart.id && cart.skus.length)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.orderService.update(cart.id, address.id, this.groupByUniqSkuId(__spreadArray(__spreadArray([], this.extractOrderSkuCreateInput(cart)), localSkus)))];

          case 2:
            _a.sent();

            return [3
            /*break*/
            , 5];

          case 3:
            return [4
            /*yield*/
            , this.orderService.create(this.marketId, address.id, localSkus)];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            this.storage.remove(BasketServiceStorage.skus);
            this.storage.remove(BasketServiceStorage.calculatedSkus);
            this.skus.clear();
            return [4
            /*yield*/
            , this.update()];

          case 6:
            return [2
            /*return*/
            , _a.sent()];

          case 7:
            error_5 = _a.sent();
            throw new LegalizeSDKError_1.default("Can not merge basket", error_5);

          case 8:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BasketService.prototype.groupByUniqSkuId = function (skus) {
    return Object.entries(skus.reduce(function (result, sku) {
      var _a;

      return __assign(__assign({}, result), (_a = {}, _a[sku.skuId] = result[sku.skuId] ? result[sku.skuId] + sku.quantity : sku.quantity, _a));
    }, {})).map(function (_a) {
      var skuId = _a[0],
          quantity = _a[1];
      return new entities_1.OrderSkuCreateInputEntity({
        skuId: Number(skuId),
        quantity: quantity
      });
    });
  };

  BasketService.prototype.handleAuthStateChange = function (state) {
    return __awaiter(this, void 0, void 0, function () {
      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = state;

            switch (_a) {
              case enums_1.AuthServiceState.authenticated:
                return [3
                /*break*/
                , 1];

              case enums_1.AuthServiceState.unauthenticated:
                return [3
                /*break*/
                , 3];
            }

            return [3
            /*break*/
            , 4];

          case 1:
            this.orderService.setAuthorization(this.authService.getToken());
            return [4
            /*yield*/
            , this.mergeBasket()];

          case 2:
            _b.sent();

            this.emit("basketReady");
            return [3
            /*break*/
            , 5];

          case 3:
            this.orderService.setAuthorization("");
            return [3
            /*break*/
            , 5];

          case 4:
            return [3
            /*break*/
            , 5];

          case 5:
            return [4
            /*yield*/
            , this.update()];

          case 6:
            _b.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return BasketService;
}(framework_1.Observer);

exports.BasketService = BasketService;